<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         :viewBox="viewBox" style="enable-background:new 0 0 107.6 126.5;" xml:space="preserve">
        <component :is="component" v-if="component" :color="settings.mouthColor" />
    </svg>
</template>

<script>
    export default {
        name: 'MouthsLoader',
        props: {
            isPreview: {
                type: Boolean,
                required: false,
                default () {
                    return false;
                },
            },
            settings: {
                type: Object,
                required: true,
            },
            mouth: {
                type: String,
                required: true,
            },
        },
        data () {
            return {
                component: null,
            }
        },
        computed: {
            viewBox () {
                return this.isPreview ? '32 30 45 50' : '0 0 107.6 126.5';
            },
            loader () {
                return () => {
                    return import(`./${this.mouth}`);
                }
            },
        },
        mounted () {
            this.loader()
                .then(() => {
                    this.component = () => this.loader()
                });
        },
    }
</script>
